<mat-dialog-content class="additional-customer-filter__container">
  @if ((error$ | async) && !customerNamesLoading) {
    <div
      fxLayout="row"
      fxLayoutAlign="space-around start">
      <error-message [error]="error$ | async"
        [page]="'Saved Group Additional Customers Dialog'">
      </error-message>
      <button type="button" class="cfa-plain-button cfa-plain-button--inline" aria-label="Close" (click)="closeDialog()"><mat-icon class="additional-customer-filter__close">close</mat-icon></button>
    </div>
  }
  @if (customerNamesLoading && !(error$ | async)) {
    <div
      class="additional-customer-filter__loading"
      [cfaLoading]="true">
    </div>
  }
  @if (!customerNamesLoading && !(error$ | async)) {
    <div
      fxLayout="column">
      <div fxLayout="row wrap" fxLayoutAlign="space-between center">
        <div class="additional-customer-filter__title">
          {{filterTitle}}
        </div>
        <button type="button" class="cfa-plain-button cfa-plain-button--inline" aria-label="Close" (click)="closeDialog()"><mat-icon class="additional-customer-filter__close">close</mat-icon></button>
      </div>
      <additional-customers-filter-table
        [(searchTerm)]="searchTerm"
        [placeHolderText]="placeHolderText"
        [dataTestId]="'customer-name-search-input'"
        [customerNames]="customerNames"
        [columns]="columns"
        [numberOfPages]="getDisplayedNumberOfPages()"
        [removeButtonText]="'Remove Selected'"
        (searchTable)="search()"
        (clearSearch)="clearSearch()"
        (allSelected)="onAllSelected($event)"
        (selection)="onSelection($event)"
        (removeSelected)="removedCustomer()">
        <data-table
          [totalElements]="getDisplayedTotalCount()"
          [frontEndPaging]="false"
          [columns]="columns"
          [rows]="customerNames"
          [currentPage]="getDisplayedCurrentPage()"
          [pageSize]="pageSize"
          [numberOfPages]="getDisplayedNumberOfPages()"
          [canSelectAll]="false"
          (onPageChange)="onCustomerPageChange($event)"
          (onAllSelected)="onAllSelected($event)"
          (onSelection)="onSelection($event)">
        </data-table>
      </additional-customers-filter-table>
    </div>
  }
</mat-dialog-content>
